// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/weui/dist/style/weui.min.css
// module id = 645
// module chunks = 0